import {
  Directive,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges
} from "@angular/core";

@Directive({
  selector: "[htmlContent]",
  standalone: false
})
export class HtmlContentDirective implements OnChanges {
  @Input() htmlContent: string | undefined;

  constructor(private elementRef: ElementRef<HTMLElement>) {}

  ngOnChanges(changes: SimpleChanges): void {
    const htmlContentChanges = changes["htmlContent"];

    if (htmlContentChanges) {
      this.elementRef.nativeElement.innerHTML = htmlContentChanges.currentValue;
    }
  }
}
